import React, { Component } from 'react'
import { MDBContainer,  MDBJumbotron,  MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon,  
    MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBDataTable, MDBInput, MDBTooltip,Button } from "mdbreact";
import Axios from 'axios'
import { Layout, Menu, Breadcrumb, Icon, Select, Card, Input   } from 'antd';
import { StarOutlined, StarFilled, StarTwoTone, CaretDownOutlined } from '@ant-design/icons';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import {  MDBRow, MDBCol } from "mdbreact";
import Modalsentedit from './Modalsentedit';


export default class Classroom extends Component {

    constructor(props) {
        super(props);
        this.state = {
          articlesci1:[],
          emp:[],
          term:'',
          empcouncil:[],
          classroom:[],
          modal: false,
          idExpert:'',
         
          idemp:'',
          citizen_id:'',
          employee_name:'',
          type:'2',
          search: '',
          research: [],
          loading:false,

          id_room:'',
          name_room:'',
          type_room:'-',
          building_name:'-',
          amount:'',

          building:[],






        };
        this.handleChange = this.handleChange.bind(this);

        this.onChange = this.onChange.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.getthcouncil = this.getthcouncil.bind(this);
        this.getclassroom = this.getclassroom.bind(this);
        this.updateSearch = this.updateSearch.bind(this);
        this.onTextChange = this.onTextChange.bind(this);
      }


      componentDidMount() {
        this.setState({ loading: true})
        setTimeout(() => {
           //ภายใน
            Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/getclassroom')
              // Axios.get('https://research.kpru.ac.th/Api_Research/index/research_search')
           .then(res => {
          //   console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ classroom: res.data})
             this.setState({ loading: false})
           }) 
         }, 0);

         setTimeout(() => {
          //ภายใน
           Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/getbuilding')
             // Axios.get('https://research.kpru.ac.th/Api_Research/index/research_search')
          .then(res => {
         //   console.log(res);
          //  this.setState({ bankname: res.data, loading: false })
            this.setState({ building: res.data})
            this.setState({ loading: false})
          }) 
        }, 0);




      }

      onTextChange = (e) => {

        this.setState({ [e.target.name]: e.target.value })
      }

      getclassroom() {

        setTimeout(() => {
           //ภายใน
            Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/getclassroom')
              // Axios.get('https://research.kpru.ac.th/Api_Research/index/research_search')
           .then(res => {
           //  console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ classroom: res.data})
           
           }) 
         }, 0);

      }


      getthcouncil() {
        setTimeout(() => {
           //ภายใน
            Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/getthcouncil/2/'+this.state.term)
           .then(res => {
          //   console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ empcouncil: res.data})
           }) 
         }, 0);
      }

      updateSearch(event) {
        this.setState({ search: event.target.value.substr(0, 20) });
      
    }


    updateSearchDepartment(event) {
       // console.log(event.target.value)
       const term = event.target.value;
       this.setState({ term });

       setTimeout(() => {
        this.getthcouncil()
      }, 500);
     }


     toggle = () => {
      this.setState({
        modal: !this.state.modal,
        id_room:'',
        name_room:'',
        type_room:'-',
        building_name:'-',
        amount:'',
      });
    }

    handleChange(event) {    this.setState({idExpert: event.target.value});  }

    
    onChange(value) {
        //  console.log(`selected ${value}`);




     // Axios.get('https://mua.kpru.ac.th/FrontEnd_Mis/employee/procSEmpInfo/'+value)
      //  .then(res => {
         // console.log(res.data.procSEmpInfo[0].citizen_id);
        //  this.setState({ bankname: res.data, loading: false })
       //   this.setState({ citizen_id: res.data.procSEmpInfo[0].citizen_id})
       //   this.setState({ idemp: res.data.procSEmpInfo[0].employee_id})
       //   this.setState({ employee_name: res.data.procSEmpInfo[0].employee_name})
      //  })
    
         //  const idemp = value;
         //  this.setState({ idemp });
    }
    
     onBlur() {
      console.log('blur');
    }
    
     onFocus() {
      console.log('focus');
    }
    
     onSearch(val) {
      console.log('search:', val);
    }

    handleSubmit () {
        
        const dataadd = new FormData();
        dataadd.append("id_room", this.state.id_room);
        dataadd.append("name_room", this.state.name_room);
        dataadd.append("type_room", this.state.type_room);
        dataadd.append("building_name", this.state.building_name);
        dataadd.append("amount", this.state.amount);
      
        Axios.post('https://git.kpru.ac.th/FrontEnd_Tabian/load/Addroom/',dataadd)
       
        .then(res => {
        //    console.log(res);
            if (res.status === 200) {
            //  alert("บันทึกสำเร็จ")
                      Swal.fire({
                          title: 'บันทึกข้อมูลสำเร็จ',
                          //text: 'มหาวิทยาลัยราชภัฏกำแพงเพชรขอขอบคุณ',
                          icon: 'success',
                        // showCancelButton: true,
                          confirmButtonText: 'ตกลง',
                        // cancelButtonText: 'No, keep it'
                        }).then((result) => {
                        
                        })
                     }
                })
             this.toggle()
             this.getclassroom()

      }



    render() {
     //   console.log(this.state.classroom)
     console.log(this.state.id_room)
     console.log(this.state.name_room)
     console.log(this.state.amount)

        const { Option } = Select;
        
        let filteredPage = this.state.classroom.filter(
            (classroom) => {
              return (classroom.id_room.indexOf(this.state.search) !== -1) 
            }
          )

        //   const persons = !data ?  <h2>loading...</h2>:<MDBDataTable
        //     searching ={false}
        //     striped
        //     bordered
        //     hover
        //     data={data}
        //     entriesLabel="จำนวนที่แสดง "
        //     infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}

        //     responsive 
        //     />

         //ชุดตาราง
         const data = {
          columns: [
            {
              label: '#',
              field: 'list',
              sort: 'list',
              width: 150
            },
            {
              label: 'รหัสห้อง',
              field: 'Course_YEAR',
              sort: 'Course_YEAR',
              width: 150
            },
            {
              label: 'ชื่อห้อง',
              field: 'Curriculumopen_TEAM',
              sort: 'Curriculumopen_TEAM',
              width: 270
            },
            {
              label: 'จำนวนที่นั่ง',
              field: 'Curriculumopen_Full_Name_TH',
              sort: 'Curriculumopen_Full_Name_TH',
              width: 200
            },
            {
              label: 'อาคาร',
              field: 'buildingname',
              sort: 'buildingname',
              width: 200
            },
            {
              label: 'จัดการ',
              field: 'Curriculumopen_Full_Name_EN',
              sort: 'Curriculumopen_Full_Name_EN',
              width: 100
            }
          ],

          rows: [...filteredPage.map((data, i) => (
            {
               list: <>{i+1}</>,
               Course_YEAR: <>{data.id_room}</>,
               Curriculumopen_TEAM: <>{data.name_room}</>,
               Curriculumopen_Full_Name_TH: <>{data.amount}</>,
               buildingname: <>{data.buildingname}</>,
               Curriculumopen_Full_Name_EN: <> <Modalsentedit id={data.id} id_send={data.id_room} name_room={data.name_room} amount={data.amount} getclassroom ={this.getclassroom}/></>,         
            }
           ))]
          
      
      };

      const persons = <MDBDataTable
      // searching ={true}
       searchLabel="ค้นหา ห้อง"
       striped
       bordered
       small 
       entries={20}
      // entriesOptions={["10", "20"]}
       order={["age", "desc"]}
       data={data}
       entriesLabel="จำนวนที่แสดง "
       infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
       paginationLabel={["ย้อนกลับ", "ถัดไป"]}
       responsive 
       sortRows={['random']}
       />





        return (
        <MDBContainer fluid>
          <Card type="inner"  title={<h4><MDBIcon icon="person-booth" /> จัดการห้องเรียน</h4>} >
            {/* <MDBAlert color="primary" >
            <h4><MDBIcon icon="address-book" className="indigo-text pr-3" /> จัดการห้องเรียน</h4>
            </MDBAlert> */}
            
            {/* <div>
            <CaretDownOutlined style={{ fontSize: '30px', color: '#0d47a1' }}  /> <select className="browser-default custom-select" style={{ width: '30%' }}   onChange={this.updateSearchDepartment.bind(this)}   icon="user" >
                <option>เลือกเทอม</option>
                <option value="3/2563">3/2563</option>
                <option value="1/2564">1/2564</option>
                <option value="2/2564">2/2564</option>
                <option value="3/2564">3/2564</option>
                <option value="1/2565">1/2565</option>
                <option value="2/2565">2/2565</option>
               
                </select>    
                
                 <br/>
            </div> */}
            <br/>

         
             {/* <h5 className="text-center">ข้อมูลห้องเรียน</h5>  */}
          
          {this.state.loading === true ? <>
            <MDBRow>
        <MDBCol></MDBCol>
        <MDBCol className="text-center">
            <div className="spinner-border text-primary" role="status">
            <span className="sr-only text-center">Loading...</span>
            </div>
        </MDBCol>
        <MDBCol></MDBCol>
      </MDBRow>
            
            </>: <>

            
            <MDBRow>
                <MDBCol size="6"> <MDBInput className="d-flex justify-content-end" label="ค้นหาห้อง"  style={{ width: '50%' }}  onChange={this.updateSearch.bind(this)} icon="user"  /> </MDBCol>
                <MDBCol size="6" className="text-right"> <MDBBtn onClick={this.toggle} color="primary" className="text-right"> <MDBIcon far icon="address-book" />  เพิ่มข้อมูล </MDBBtn></MDBCol>
              
            </MDBRow>


            {persons}
            
            {/* <MDBTable bordered small>
                <MDBTableHead color="grey lighten-1" textWhite>
                    <tr>
                    <th>ลำดับ</th>
                    <th>รหัสห้อง</th>
                    <th>ชื่อห้อง</th>
                    <th>จำนวนที่นั่ง</th>
                    <th>จัดการ</th>
                    </tr>
                </MDBTableHead>
                <MDBTableBody>
                {filteredPage.map((classroom,index) => {
                  return <tr>
                          <td>{index+1}</td>
                          <td>{classroom.id_room}</td>
                          <td>{classroom.name_room}</td>
                          <td>{classroom.amount}</td>
                          <td width="50">
                               <Modalsentedit id_send={classroom.id_room} name_room={classroom.name_room} amount={classroom.amount} getclassroom ={this.getclassroom}/> 
                          </td>
                          </tr>
                })}   
                </MDBTableBody>
            </MDBTable> */}
            </> }
            {/* <p>หมายเหตุ : ข้อมูลใช้ประกอบการจัดตารางสอน ไม่ให้ชนกับการประชุม</p> */}
     
            <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
              <MDBModalHeader toggle={this.toggle}>เพิ่มข้อมูลห้องเรียน </MDBModalHeader>
              <MDBModalBody>
            
                  {/* <Select
                    showSearch
                    style={{ width: 300 }}
                    placeholder="เพิ่มข้อมูลห้อง"
                    optionFilterProp="children"
                    onChange={this.onChange}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                    onSearch={this.onSearch}
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                   
                   
                   {this.state.emp.map((emp,index )  => 
                   <option value={emp.employee_id}>{emp.employee_name}</option>
                   )}
                  </Select> */}
                <div className="form-group">
                <label htmlFor="example2"> รหัสห้อง </label><br/>
                <Input placeholder="รหัสห้อง"  style={{ width: '100%'}} value={this.state.id_room} name="id_room" onChange={this.onTextChange} required  />
                   {/* <input type="text" id="example2"  placeholder="ชื่อ" className="form-control form-control-md" value={this.state.Studentcb_NAME} name="Studentcb_NAME" onChange={this.onTextChange} required /> */}
                </div>

                <div className="form-group">
                <label htmlFor="example2"> ชื่อห้อง </label><br/>
                <Input placeholder="ชื่อห้อง"  style={{ width: '100%' }} value={this.state.name_room} name="name_room" onChange={this.onTextChange} required  />
                   {/* <input type="text" id="example2"  placeholder="ชื่อ" className="form-control form-control-md" value={this.state.Studentcb_NAME} name="Studentcb_NAME" onChange={this.onTextChange} required /> */}
                </div>


                  {/* <Select
                    showSearch
                    style={{ width: 300 }}
                    placeholder="เพิ่มข้อมูลห้อง"
                    optionFilterProp="children"
                    onChange={this.onChange}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                    onSearch={this.onSearch}
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                   
                   
                   {this.state.building.map((building,index )  => 
                   <option value={building.building_id}>{building.employee_name}</option>
                   )}
                  </Select> */}


                <div className="form-group">
                <label htmlFor="example2"> จำนวนที่นั่ง </label><br/>
                <Input placeholder="จำนวนที่นั่ง"  style={{ width: '100%' }} value={this.state.amount} name="amount" onChange={this.onTextChange} required  />
                   {/* <input type="text" id="example2"  placeholder="ชื่อ" className="form-control form-control-md" value={this.state.Studentcb_NAME} name="Studentcb_NAME" onChange={this.onTextChange} required /> */}
                </div>

                  <MDBBtn color="dark-green" size="sm" value={this.state.Studentcb_Citizen_ID} name="Studentcb_Citizen_ID" onClick={this.handleSubmit}>เพิ่มห้องเรียน</MDBBtn>

              </MDBModalBody>
              <MDBModalFooter>
                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
                {/* <MDBBtn color="dark-green">Save changes</MDBBtn> */}
              </MDBModalFooter>
            </MDBModal>
            </Card>
        </MDBContainer>
        
        )
    }
}
